import React from 'react';

const BAConfirmDriverIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.66406 17.5C1.66399 16.2169 2.03417 14.9611 2.73018 13.8832C3.42619 12.8054 4.41846 11.9512 5.5879 11.4233C6.75733 10.8955 8.05426 10.7163 9.32303 10.9072C10.5918 11.0982 11.7785 11.6513 12.7407 12.5M13.3307 15.8333L14.9974 17.5L18.3307 14.1667M12.4974 6.66667C12.4974 8.96785 10.6319 10.8333 8.33073 10.8333C6.02954 10.8333 4.16406 8.96785 4.16406 6.66667C4.16406 4.36548 6.02954 2.5 8.33073 2.5C10.6319 2.5 12.4974 4.36548 12.4974 6.66667Z'
        stroke='#6B7280'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default BAConfirmDriverIcon;
